module.exports = __webpack_public_path__ + "assets/img/sph_ewm.e4b7ac9f.jpg";